import { saveAs } from 'file-saver';
export default {
  name: 'cheader',
  props: {
    activeIndex: {
      type: String,
      default: '/',
    }
  },
  data() {
    return {
      unread: 0,
      isWayShow: false,
      isWayShowNew:false,
      fileList: [],
      timer: '',
      progressVal: 0,
      vipTitle:"",
      progressDisplay: false,
      mergeFlag:"",
      serverUrl: this.$store.state.config.serverUrl
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.vipTitle = this.user.vipLevel=="11"?"svip":""
    this.unreadIndex()
    this.orderSwitch()
  },
  methods: {
    go(url) {
      this.$router.push(url)
      window.location.reload()
    },
    addVal() {
      if (this.progressVal <= 95) {
        this.progressVal++;
      }
    },
    startProgress() {
      this.progressDisplay = true;
      this.timer = setInterval(this.addVal, 500);
    },
    endProgress() {
      this.progressVal = 0;
      this.progressDisplay = false;
    },
    uploadTemplate(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.startProgress()
      this.$http.post(`/api/excelUpload/inquiry?userId=${this.user.id}`, formData).then((res) => {
        if (res.data.success) {
          if(res.data.message!="转化成功"){
            let str = res.data.message
            let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
            saveAs(strData, "错误信息提示.txt");
          }
          this.progressVal = 100;
          window.location.href = `/#/inquiry/create/excel/${res.data.data}`
        } else {
          this.endProgress()
          this.$message.warning(res.data.message)
        }
      })
    },
    uploadTemplateNew(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.startProgress()
      this.$http.post(`/api/excelUpload/salesman/inquiry?userId=${this.user.id}`, formData).then((res) => {
        if (res.data.success) {
          if(res.data.message!="转化成功"){
            let str = res.data.message
            let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
            saveAs(strData, "错误信息提示.txt");
          }
          this.progressVal = 100;
          window.location.href = `/#/inquiryNew/create/excel/${res.data.data}`
        } else {
          this.endProgress()
          this.$message.warning(res.data.message)
        }
      })
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    unreadIndex() {
      if (this.user.id) {
        this.$http.get('/api/unReadMessageCount', {params: {userId: this.user.id}}).then((res) => {
          this.unread = res.data.data
        })
      }
    },
    orderSwitch() {
      if (this.user.id) {
        this.$http.get('/api/user/orderSwitch', {params: {comId: this.user.customerId}}).then((res) => {
          this.mergeFlag = res.data.message
        })
      }
    },
   
    logout() {
      this.$http.get('/api/user/signOut', {params: {userId: this.user.id}}).then((res) => {
       
      })
      this.$store.commit('logout')
      window.location.href = '/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/header/index.js